import { Fragment, useEffect, useState } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
//--------------------------------------------------------------------------------------------
import TransitionWidthHeight from "src/components/common/TransitionWidthHeight";
import Resize from "src/components/common/resize";
import magnifierImg from "src/img/magnifier.png";
import UserInfo from "src/components/common/userInfo";
import Footer from "src/components/common/frame/footer";
import { useMyStore } from "src/components/main/mainStore";
import {
    weeknum, getDatefromWeekNum0, MyDate, 
    myAxios, MyFormData, getTimeStamp, 
    boolAndReducer, simpleStatusColorCode, objAscSort, 
    scroll, isDevMode, reportWriterEmails,
    appTitle, 
} from "src/components/common/functions";
import Detail from "./detail";
import FilterForm from "./filter";
import Export from "./export";
import ReportForm from "./reportForm";
import WeekSelect from "../common/frame/weekSelect";
const title = "Reports";
//--------------------------------------------------------------------------------------------
export default function Reports({ tabTitle }){
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const user = useMyStore(state => state.user);
    const [updateDateTime, setUpdateDateTime] = useState(getTimeStamp());
    //--------------------------------------------------------------------------------------------
    const defaultFilter = {
        void: "", 
        projectName: "",
        startDateMin: "",
        startDateMax: "",
        endDateMin: "",
        endDateMax: "",
        potholeMin: "",
        potholeMax: "",
        epMin: "",
        epMax: "",
        manholeMin: "",
        manholeMax: "",
        code: "",
        priority: "",
        pending: "All",
        sup: "All", 
        hasFile: "",
        reportTechEmail: "",
        status: "",
        notes: "",
        projectManagerEmail: "",
        approverNotes: "",
        createdBy: "", 
        submitTimeMin: "",
        submitTimeMax: "",
        updatedBy: "", 
        updateTimeMin: "",
        updateTimeMax: "",
    };
    const [curFilter, setFilter] = useState(defaultFilter);
    const [showFilter, setShowFilterForm] = useState(false);
    const [curApproval, setApproval] = useState("");
    //--------------------------------------------------------------------------------------------
    const [curWeekStart, setWeekStart] = useState(weeknum(new MyDate()));
    const [curWeekEnd, setWeekEnd] = useState(weeknum(new MyDate()));
    const [userList, setUserList] = useState([]);
    const [showLoading, setShowLoading] = useState(false);
    const [usersList, setUsersList] = useState([]);
    const usersListMap = Object.fromEntries(usersList.map(user => [user.email, `${user.userName}`]))
    const [projectsList, setProjectsList] = useState([]);
    const projectsListMap = Object.fromEntries(projectsList.map(project => [project.projectHashKey, project.projectName]));
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [filterWords, setFilterWords] = useState("");
    const reportWriterList = usersList.filter(user => reportWriterEmails.includes(user.email));
    //--------------------------------------------------------------------------------------------
    const history = useHistory();
    const location = useLocation();
    //--------------------------------------------------------------------------------------------
    const deleteUser = async e => {
        if(!window.confirm("Are you sure to void this report?")) return;
        let voidReason = window.prompt("reason to void:");
        if(voidReason === null) return;
        while(voidReason === ""){
            window.alert("Reason is required to void.");
            voidReason = window.prompt("reason to void:");
            if(voidReason === null) return;
        }
        const formData = new MyFormData();
        formData.append("reportHashKey", e.currentTarget.id);
        formData.append("voidReason", voidReason);
        formData.append("start", getDatefromWeekNum0(curWeekStart, 0).s());
        formData.append("end", getDatefromWeekNum0(curWeekEnd, 7).s());
        //-------------------------------------------------
        setShowLoader(true);
        const res = await myAxios("reports/void.php", formData);
        setShowLoader(false);
        if(!res) return;
        //-------------------------------------------------
        setUserList(res.data);
        history.replace(`/${title}`);
        scroll(null);
    }
    const restoreUser = async e => {
        if(!window.confirm("Are you sure to re-valid this report?")) return;
        const formData = new MyFormData();
        formData.append("reportHashKey", e.currentTarget.id);
        formData.append("start", getDatefromWeekNum0(curWeekStart, 0).s());
        formData.append("end", getDatefromWeekNum0(curWeekEnd, 7).s());
        //-------------------------------------------------
        setShowLoader(true);
        const res = await myAxios("reports/restore.php", formData);
        setShowLoader(false);
        if(!res) return;
        //-------------------------------------------------
        setUserList(res.data);
        history.replace(`/${title}`);
    }
    const notify = async e => {
        if(!window.confirm("Are you sure to notify the approver?")) return;
        const formData = new MyFormData();
        formData.append("reportHashKey", e.currentTarget.id);
        formData.append("start", getDatefromWeekNum0(curWeekStart, 0).s());
        formData.append("end", getDatefromWeekNum0(curWeekEnd, 7).s());
        //-------------------------------------------------
        setShowLoader(true);
        const res = await myAxios("reports/notify.php", formData);
        setShowLoader(false);
        if(!res) return;
        //-------------------------------------------------
        setUserList(res.data);
        history.replace(`/${title}`);
        scroll(null);
    }
    const editUser = () => {
        history.push(`/${title}/${id}/Edit`);
    }
    //--------------------------------------------------------------------------------------------
    const id = location.pathname.split("/")[2];
    const idid = location.pathname.split("/")[3];
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const filterUserList = userList?.map(r => 
        ({...r, 
            projectName: projectsListMap[r.projectHashKey],
            reportTech: usersListMap[r.reportTechEmail] ?? "",
            submitter: usersListMap[r.submitterEmail] ?? "",
            updater: usersListMap[r.updaterEmail],
            requestor: usersListMap[r.requestorEmail],
            projectManager: usersListMap[r.projectManagerEmail],
            stats: [
                r.pothole?r.pothole + "Ps":"", 
                r.ep?r.ep + "EPs":"", 
                r.manhole?r.manhole + "MHs":""
            ].filter(value => value).join(", "),
            hasFile: r.pdfId?"Yes":"No"
        })
    ).filter(u => 
        (curFilter.void === "All"?true:(u.void === curFilter.void))
        && (curFilter.projectName?u.projectName.toLowerCase().indexOf(curFilter.projectName.toLowerCase()) > -1:true)
        && (curFilter.startDateMin? u.startDate && new Date(u.startDate) >= new Date(curFilter.startDateMin):true)
        && (curFilter.startDateMax? u.startDate && new Date(u.startDate) <= new Date(curFilter.startDateMax):true)
        && (curFilter.endDateMin?u.endDate && new Date(u.endDate) >= new Date(curFilter.endDateMin):true)
        && (curFilter.endDateMax?u.endDate && new Date(u.endDate) <= new Date(curFilter.endDateMax):true)
        && (curFilter.potholeMin?window.Number.parseFloat(u.pothole) >= window.Number.parseFloat(curFilter.potholeMin):true)
        && (curFilter.potholeMax?window.Number.parseFloat(u.pothole) <= window.Number.parseFloat(curFilter.potholeMax):true)
        && (curFilter.epMin?window.Number.parseFloat(u.ep) >= window.Number.parseFloat(curFilter.epMin):true)
        && (curFilter.epMax?window.Number.parseFloat(u.ep) <= window.Number.parseFloat(curFilter.epMax):true)
        && (curFilter.manholeMin?window.Number.parseFloat(u.manhole) >= window.Number.parseFloat(curFilter.manholeMin):true)
        && (curFilter.manholeMax?window.Number.parseFloat(u.manhole) <= window.Number.parseFloat(curFilter.manholeMax):true)
        && (curFilter.code?u.code.toLowerCase().indexOf(curFilter.code.toLowerCase()) > -1:true)
        && (!curFilter.priority?true:u.priority === curFilter.priority)
        && (curFilter.pending === "All"?true:u.pending === curFilter.pending)
        && (curFilter.sup === "All"?true:u.sup === curFilter.sup)
        && (!curFilter.hasFile?true:u.hasFile === curFilter.hasFile)
        && (!curFilter.reportTechEmail?true:u.reportTechEmail === curFilter.reportTechEmail)
        && (!curFilter.status?true:curFilter.status.map(item => item.value).includes(u.status))
        && (curFilter.notes?u.notes.toLowerCase().indexOf(curFilter.notes.toLowerCase()) > -1:true)
        && (!curFilter.projectManagerEmail?true:u.projectManagerEmail === curFilter.projectManagerEmail)
        && (curFilter.approverNotes?u.approverNotes.toLowerCase().indexOf(curFilter.approverNotes.toLowerCase()) > -1:true)
        && (curFilter.createdBy?u.submitterEmail === curFilter.createdBy:true)
        && (curFilter.submitTimeMin?new Date(u.submitTime) >= new Date(curFilter.submitTimeMin):true)
        && (curFilter.submitTimeMax?new Date(u.submitTime) <= new Date(curFilter.submitTimeMax):true)
        && (curFilter.updatedBy?u.updaterEmail === curFilter.updatedBy:true)
        && (curFilter.updateTimeMin?new Date(u.updateTime) >= new Date(curFilter.updateTimeMin):true)
        && (curFilter.updateTimeMax?new Date(u.updateTime) <= new Date(curFilter.updateTimeMax):true) 
        && (filterWords.toLowerCase().split(" ").map(f => JSON.stringify(
            Object.values(u)
        ).toLowerCase().indexOf(f) > -1).reduce(boolAndReducer, true))
    );
    const currentUserList = filterUserList.slice(indexOfFirstItem, indexOfLastItem);
    const pageNumbers = Array.from({length: Math.ceil(filterUserList.length / itemsPerPage)}, (_, i) => (i + 1));
    //--------------------------------------------------------------------------------------------
    useEffect(() => {
        if(isDevMode) console.log("useEffect");
        let isMounted = true;
        const controller = new AbortController();
        const getData = async() => {
            const id = decodeURIComponent(history.location.pathname.split("/")[2] ?? "");
            //-------------------------------------------------
            setShowLoading(true);
            const resUser = await myAxios("common/readUserNames.php", undefined, undefined, controller.signal);
            if(!isMounted) return;
            if(!resUser){
                setShowLoading(false);
                return;
            }
            //-------------------------------------------------
            setUsersList(resUser.data.map(u => ({...u, label:`${u.firstName} ${u.middleName} ${u.lastName}`, value: u.email})));
            //-------------------------------------------------
            setShowLoading(true);
            const resProject = await myAxios("projects/readProjectsForPurchase.php", undefined, undefined, controller.signal);
            if(!isMounted) return;
            if(!resProject){
                setShowLoading(false);
                return;
            }
            //-------------------------------------------------
            const projectsData = resProject.data.sort((a, b) => objAscSort(a, b, "projectName"));
            setProjectsList(projectsData.map(p => ({...p, value: p.projectHashKey, label:p.projectName})));
            //------------------------------------------------------------------------------------------------------
            let thisReport = "";
            const formData = new MyFormData();
            if(id !== "Add" && id !== ""){
                formData.append("reportHashKey", id);
                const reportRes = await myAxios("reports/readReport.php", formData);
                if(!isMounted) return;
                if(!reportRes){
                    setShowLoading(false);
                    return;
                }
                thisReport = reportRes.data;
                if(thisReport === ""){
                    history.push(`/${title}`);
                }else{
                    if(thisReport.void){setFilter(f => ({...f, void: "yes"}));}
                    setWeekStart(weeknum(thisReport.updateTime.substring(0, 10)));
                    setWeekEnd(weeknum(thisReport.updateTime.substring(0, 10)));
                }
            }
            //------------------------------------------------------------------------------------------------------
            formData.append("start", getDatefromWeekNum0(curWeekStart, 0).s());
            formData.append("end", getDatefromWeekNum0(curWeekEnd, 7).s());
            //-------------------------------------------------
            const res = await myAxios("reports/readReports.php", formData, undefined, controller.signal);
            if(!isMounted) return;
            setShowLoading(false);
            if(!res) return;
            //-------------------------------------------------
            setUserList(res.data);
            if(thisReport){
                const hashkeys = res.data
                .filter(u => u.void === thisReport.void)
                .filter(u => weeknum(u.updateTime.substring(0, 10)) === weeknum(thisReport.updateTime.substring(0, 10)))
                .map(v => v.reportHashKey);
                setCurrentPage(Math.ceil((hashkeys.indexOf(id) + 1) / itemsPerPage));
                scroll(id);
            }
            //------------------------------------------------------------------------------------------------------
        }
        getData();
        return () => {
            isMounted = false;
            controller.abort();
        }
    },[history, curWeekStart, curWeekEnd, updateDateTime]);
    useEffect(() => {
        document.title = tabTitle;
        return () => {
            document.title = appTitle;
        };
    }, [tabTitle]);
    //--------------------------------------------------------------------------------------------
    return(
        <div className = "cssTab">
            <div className = "cssHeader" style = {{background: user.userTheme}}>
                <span>
                    <Resize/>
                    Reports
                    <span data-toggle = "tooltip" title = {"Refreshed on " + updateDateTime} className = "btn btn-primary py-1 ml-4" onClick = {() => setUpdateDateTime(getTimeStamp())}>↻</span>
                </span>
                <span>
                    <input
                        className = "form-control w-auto"
                        type = "text"
                        value = {filterWords}
                        onChange = {e => {
                            setFilterWords(e.currentTarget.value.toLowerCase());
                            setCurrentPage(1);
                        }}
                    />
                    <img alt = "" src = {magnifierImg}/>
                </span>
                {userList.find(u => u.approverEmail === user.email)?
                <select className = "form-control w-auto" value = {curApproval} onChange = {e => {
                    setApproval(e.currentTarget.value);
                    setCurrentPage(1);
                }}>
                    <option value = "">All Reports</option>
                    <option value = "all">All My Approval</option>
                    <option value = "need">Need My Approval</option>
                </select>
                :<></>}
                <WeekSelect
                    curWeekStart = {curWeekStart}
                    setWeekStart = {setWeekStart}
                    curWeekEnd = {curWeekEnd}
                    setWeekEnd = {setWeekEnd}
                    setCurrentPage = {setCurrentPage}
                    history = {history}
                    path1 = {title}
                    beginWeek = "2024/1/31"
                />
                <span className = "pointer rounded p-1" style = {{
                    backgroundColor: Object.entries(curFilter).find(([key, value]) => defaultFilter[key] !== value)?
                    "rgb(0,123,255)"
                    :undefined
                }} onClick = {() => {setShowFilterForm(true)}}>
                    Filter
                </span>
                {showFilter?
                <FilterForm
                    userList = {userList}
                    usersListMap = {usersListMap}
                    setCurrentPage = {setCurrentPage}
                    curFilter = {curFilter}
                    setFilter = {setFilter}
                    closeIt = {() => setShowFilterForm(false)}
                    defaultFilter = {defaultFilter}
                    reportWriterList = {reportWriterList}
                />:<></>}
                <Export
                    usersListMap = {usersListMap}
                    filterUserList = {filterUserList}
                />
                <span className = "pointer" onClick = {() => {history.push(`/${title}/Add`);}}>Add</span>
                {id === "Add"?
                <ReportForm
                    reportWriterList = {reportWriterList}
                    curWeekStart = {curWeekStart}
                    curWeekEnd = {curWeekEnd}
                    setUserList = {setUserList}
                    history = {history}
                    id = {id}
                    projectsList = {projectsList}
                    usersList = {usersList}
                    closeIt = {() => history.push(`/${title}`)}
                    keyword = "Add" 
                    action = "create"
                />:<></>}
            </div>
            <div className = "cssContent pb10">
                {showLoading?<div className = "cssLoading">Loading...</div>:
                !filterUserList.length?<div className = "cssLoading">Empty</div>:
                <div className = "table-responsive">
                    <table className = "table text-center">
                        <thead>
                            <tr className = "noBorderTop">
                                <th></th>
                                <th>Project</th>
                                <th>Start Date</th>
                                <th>End Date</th>
                                <th>Stats</th>
                                <th>Code</th>
                                <th>Priority</th>
                                <th>Pending on Other Department</th>
                                <th>Supplementary Report</th>
                                <th>File</th>
                                <th>Report Tech</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentUserList.map((report, key) => 
                            <Fragment key = {key}>
                            <tr
                                id = {report.reportHashKey}
                                className = "pointer"
                                style = {{
                                    color:simpleStatusColorCode[report.status]
                                }}
                                onClick = {e => {
                                    if(e.target.id === ""){
                                        if(id !== e.currentTarget.id){
                                            history.push(`/${title}/${e.currentTarget.id}`);
                                            scroll(e.currentTarget.id);
                                        }else{
                                            history.push(`/${title}`);
                                            scroll(null);
                                        }
                                    }
                                }}
                            >
                                <td className = {id === report.reportHashKey?"showMinus":"showPlus"}></td>
                                <td>
                                    <Link id = {report.projectHashKey} to = {`/Projects/${report.projectHashKey}`}>
                                        {report.projectName}
                                    </Link>
                                </td>
                                <td>{report.startDate}</td>
                                <td>{report.endDate}</td>
                                <td>
                                    {report.stats}
                                </td>
                                <td>
                                    {report.code}
                                </td>
                                <td>
                                    {report.priority}
                                </td>
                                <td>
                                    {report.pending}
                                </td>
                                <td>
                                    {report.sup}
                                </td>
                                <td>
                                    {report.pdfId?
                                    <a
                                        id = {report.reportHashKey + " file"}
                                        className = "btn btn-primary"
                                        href = {`https://drive.google.com/file/d/${report.pdfId}/view?usp=drivesdk`}
                                        target = "_blank"
                                        rel = "noreferrer"
                                    >
                                        View
                                    </a>:<></>}
                                </td>
                                <td>
                                    <UserInfo
                                        name = {report.reportTech}
                                        email = {report.reportTechEmail}
                                    />
                                </td>
                                <td>
                                    {report.status}
                                </td>
                            </tr>
                            <tr>
                                <td className = "noborder" colSpan = {100}>
                                <TransitionWidthHeight 
                                    classNames = "cssTDTransition"
                                    In = {history.location.pathname.split("/")[2] === report.reportHashKey}
                                >
                                    <Detail
                                        reportWriterList = {reportWriterList}
                                        setCurrentPage = {setCurrentPage}
                                        itemsPerPage = {itemsPerPage}
                                        setFilter = {setFilter}
                                        setWeekStart = {setWeekStart} 
                                        setWeekEnd = {setWeekEnd}
                                        setUserList = {setUserList}
                                        id = {id}
                                        idid = {idid}
                                        report = {report}
                                        history = {history}
                                        deleteUser = {deleteUser}
                                        restoreUser = {restoreUser}
                                        notify = {notify}
                                        editUser = {editUser}
                                        usersList = {usersList}
                                        usersListMap = {usersListMap}
                                        projectsList = {projectsList}
                                        curWeekStart = {curWeekStart}
                                        curWeekEnd = {curWeekEnd}
                                    />
                                    </TransitionWidthHeight>
                                </td>
                            </tr>
                            </Fragment>)}
                        </tbody>
                    </table>
                </div>}
                {!showLoading && filterUserList.length?
                <Footer
                    length = {filterUserList.length}
                    pageNumbers = {pageNumbers}

                    currentPage = {currentPage}
                    setCurrentPage = {setCurrentPage}
                    itemsPerPage = {itemsPerPage}
                    setItemsPerPage = {setItemsPerPage}
                />
                :null}
            </div>
        </div>
    )
}





